<template>
  <div>
    <LoadingOverlay v-if="isFetching" />
    <div v-else class="page-fix">
      <CRow class="m-0 min-vh-100">
        <CCol
          lg="8"
          class="d-none d-lg-block p-0 campaign-bg"
          :style="!isFetching ? `background-image: url(${getBackgroundImage})` : ''"
        />
        <CCol
          cols="12"
          lg="4"
          class="d-flex align-items-start justify-content-center mt-4"
        >
          <div class="w-100">
            <div v-if="isCandidateRoleFromAccessToken" class="text-right px-4 mb-2">
              <CButton @click="goHome" class="btn-primary">
                <i class="fas fa-arrow-left me-2"></i> Back
              </CButton>
            </div>
            <div
              class="p-3 shadow bg-white rounded-4 text-center mx-auto"
              style="max-width: 420px"
            >
              <div class="logo-wrapper mx-auto mb-3">
                <img
                  class="logo-img"
                  :src="getLogoImage"
                  @error="$event.target.src = '/img/tflogo.png'"
                  alt="logo"
                />
              </div>

              <h3 class="fw-bold mb-1">
                {{ getCampaignById.campaign_name }}
              </h3>

              <p class="text-muted small mb-3">
                {{ getCampaignById.welcome_text }}
              </p>

              <hr />

              <div v-if="isCandidateRoleFromAccessToken">
                <button
                  class="btn btn-primary px-4 py-2 fw-semibold w-100"
                  @click="proceedWithCampaignQuestions(true)"
                >
                  {{ getCandidateCampaignInfo?.pre_screening_complete  ? 'View My Responses' : 'Complete My Campaign' }}
                </button>
              </div>
              <div v-else>
                <h6 class="fw-semibold mt-3 mb-3">
                  Are you already registered with {{ getOrgNameOrAcronym }}?
                </h6>

                <div class="d-flex justify-content-center">
                  <button
                    class="btn btn-primary px-4 py-2 fw-semibold"
                    @click="handleCampaignRoute(true)"
                  >
                    Yes
                  </button>

                  <button
                    class="btn btn-outline-primary px-4 py-2 fw-semibold ml-3"
                    @click="handleCampaignRoute(false)"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>

            <div
              v-if="getCampaignById?.description"
              class="p-4 bg-light rounded-4 shadow-sm mt-4 mx-auto"
              style="max-width: 420px"
            >
              <h5 class="fw-semibold mb-2 text-primary">
                About this Campaign
              </h5>
              <p class="mb-0 h6">
                {{ getCampaignById.description }}
              </p>
            </div>

            <div class="text-center mt-3">
              <button
                v-if="getCampaignById?.campaign_information"
                class="btn btn-primary fw-bold"
                @click="openCampaignAdditionalInfoModal(getCampaignById.campaign_information)"
              >
                Click to view campaign information
              </button>
            </div>
          </div>
        </CCol>
      </CRow>
      <Modal
        size="lg"
        :modalTitle="CampaignAdditionalInfoModal.title"
        :modalColor="CampaignAdditionalInfoModal.color"
        :innerHTML="CampaignAdditionalInfoModal.innerHTML"
        :isShowPopup="CampaignAdditionalInfoModal.isShowPopup"
        :buttons="CampaignAdditionalInfoModal.buttons"
        :modalCallBack="CampaignAdditionalInfoModalCallBack"
        :closeOnBackdrop="false"
      />
    </div>
  </div>
  <!-- <div class="page-fix" :style="!isFetching ? `background-image: url(${getBackgroundImage})`:''" :class="{'bg-cover' : isLessDimensionImg}">
    <CRow class="m-0" v-if="!showPasswordInput">
      <CCol class="p-0" id="bg-img" style="max-width: 680px">
        <img
          v-if="!isFetching"
          class="position-fixed d-none"
          :class="isTFW ? 'istfw' : ''"
          :src="getBackgroundImage"
          @load="getImageSize"
          :style="{
            width: `${getScreenSize.width - 17}px`,
            height: `${getScreenSize.height}px`,
          }"
          @error="
            $event.target.src = '/img/new_home_bg.png';
            $event.target.style = '';
          "
          ref="campaign_bg_img"
          alt="bg"
        />
      </CCol>
      <CCol class="d-flex justify-content-center align-items-center py-5">
        <CRow class="w-100 justify-content-center">
          <div class="p-4 shadow bg-white rounded-4 text-center" style="max-width: 420px; width: 100%">
            <div class="logo-wrapper mx-auto mb-3">
              <img class="logo-img" :src="getLogoImage" @error="$event.target.src = '/img/tflogo.png'" alt="logo" />
            </div>
            <h3 class="fw-bold mb-1">
              {{ getCampaignById.campaign_name }}
            </h3>

            <p class="text-muted small mb-3">
              {{ getCampaignById.welcome_text }}
            </p>

            <hr />


            <div v-if="isCandidateRoleFromAccessToken">
               <button class="btn btn-primary px-4 py-2 mr-2 fw-semibold" style="min-width: 120px"
                @click="proceedWithCampaignQuestions(true)">
                Click To Proceed
              </button>
            </div>
            <div v-else>
              <h6 class="fw-semibold mt-3 mb-3">
                Are you already registered with {{ getOrgNameOrAcronym }}?
              </h6>
              <div class="d-flex align-items-center justify-content-center">
                <button class="btn btn-primary px-4 py-2 mr-2 fw-semibold" style="min-width: 120px"
                  @click="handleCampaignRoute(true)">
                  Yes
                </button>

                <button class="btn btn-outline-primary px-4 py-2 fw-semibold ml-3" style="min-width: 120px"
                  @click="handleCampaignRoute(false)">
                  No
                </button>
              </div>
            </div>
          </div>

          <div v-if="getCampaignById?.description" class="mt-4 p-4 bg-light rounded-4" style="max-width: 720px; width: 100%">
            <h5 class="fw-semibold mb-2 text-primary">About this Campaign</h5>
            <p class="mb-0 h6">
              {{ getCampaignById?.description }}
            </p>
          </div>
          <div class="w-100 text-center">
            <button
              v-if="getCampaignById?.campaign_information"
              class="btn btn-link mt-3 p-0 font-weight-bold" 
              @click="openCampaignAdditionalInfoModal(getCampaignById?.campaign_information)">
              Click to view campaign information
            </button>
          </div>
        </CRow>
      </CCol>
      <CCol class="p-0">
        <div class="mt-5 col-md-8 ml-auto mr-5">
          <CCard class="border-0 bg-white">
            <CCardBody>
              <div class="mb-2">
                <div class="row">
                  <div class="col-md-4 d-flex justify-content-center">
                    <img
                      class="img-fluid rounded-circle"
                      :src="getLogoImage"
                      @error="$event.target.src = '/img/tflogo.png'"
                      alt="logo"
                    />
                  </div>
                  <div class="col-md-8 d-flex align-items-center mt-3">
                    <h4>
                      {{ getCampaignById.campaign_name }}
                    </h4>
                  </div>
                </div>
                <hr color="text-primary" size="10" />
              </div>
              <div v-if="step === 1">
              <div v-if="!isRegCandidate">
                <ValidationObserver
                  ref="login_campaign"
                  v-slot="{ handleSubmit }"
                >
                  <form @submit.prevent="handleSubmit(checkCandidateExists)">
                    <CRow>
                      <CCol>
                        <CRow class="d-flex align-items-center mb-3">
                          <label
                            name="email_label"
                            class="required col-lg-12 col-md-12"
                          >Enter Email</label>
                          <div class="col-lg-12 col-md-12 col-sm-12">
                            <ValidationProvider
                              name="email"
                              rules="required|email"
                              v-slot="{ errors }"
                            >
                              <TextInput
                                name="email"
                                v-model="candidate_email.email"
                                @input="handleEmailInput"
                                :error="errors[0]"
                              />
                            </ValidationProvider>
                          </div>
                        </CRow>
                        <CRow class="d-flex align-items-center mb-3">
                          <label
                            class="required col-lg-12 col-md-12"
                          >
                            Confirm Email
                          </label>
                          <div class="col-lg-12 col-md-12 col-sm-12">
                            <ValidationProvider
                              rules="required|email|emailConfirmed:email"
                              v-slot="{ errors }"
                            >
                              <TextInput
                                name="confirm_email"
                                v-model="candidate_email.confirm_email"
                                @input="handleEmailInput"
                                :error="errors[0]"
                              />
                            </ValidationProvider>
                          </div>
                        </CRow>
                      </CCol>
                    </CRow>
                    <div class="text-center">
                      <router-link :to='`/${getPathAcronym}`'>
                        <CButton
                          color="primary"
                          variant="outline"
                          class="mr-3 btn-width"
                          >Cancel</CButton
                        >
                      </router-link>
                      <CButton
                        class="bg-primary text-white btn-width"
                        @click="checkCandidateExists"
                        >Next</CButton
                      >
                    </div>
                  </form>
                </ValidationObserver>
              </div>
              </div>
              <div v-if="isRegCandidate && !isAlreadyRegWithCurrentOrg">
                <h5 class="text-center text-primary mb-3">
                  Already Registered
                </h5>
                <p class="font-weight-bold h4 mb-3">
                  Welcome Back
                  <span class="text-primary">{{ candidateName | toTitleCase }}</span>
                </p>
                <CRow class="mb-3">
                  <label class="col-md-3 text-primary">Email ID</label>
                  <CCol md="9">
                    <TextInput
                      name="email"
                      :value="candidateInfo.email"
                      :disabled="true"
                    />
                  </CCol>
                </CRow>
                <div v-if="candidateInfo.is_campaign">
                  <p class="mb-2">
                    You are already registered with
                    <span class="font-weight-bold">{{
                      candidateInfo.org_name || candidateInfo.customer_name
                    }},</span
                    > press Continue to complete campaign registration or Cancel to exit.
                  </p>
                  <div class="my-2 mt-5 text-center">
                    <CButton variant="outline" color="primary" @click="routeToCampaignLogin()">Cancel</CButton>
                    <CButton color="primary ml-3" @click="showPreReg">Continue</CButton>
                  </div>
                </div>
                <div v-else-if="getCampaignById.is_tfw_campaign">
                  TFW campaign – candidate registered with another TF Customer
                  <p class="mb-2">
                    Your details are already registered with
                    <span class="font-weight-bold">
                      {{ candidateInfo.org_name || candidateInfo.customer_name }}
                    </span>, a member of the TalentFind Marketplace network – 
                    the global healthcare careers hub 
                  </p>
                  <p>
                    Press Confirm to use your 
                    <b class="font-weight-bold">{{ getOrgNameOrAcronym }}</b>
                     profile to quickly register with Talentfind Marketplace and
                     this campaign or Cancel to exit.
                  </p>
                </div>
                <div v-else-if="!getCampaignById.is_tfw_campaign && candidateInfo?.organisation_id === 148">
                  Non-TFW campaign – candidate registered with another TF Customer
                  <p class="mb-2">
                    <span class="font-weight-bold">
                      {{ candidateInfo.org_name || candidateInfo.customer_name }}
                    </span>, is a member of the TalentFind Marketplace network – the global
                    healthcare careers hub. You’re already registered and have a
                    TalentFind profile. 
                  </p>
                  <p>
                    Press Confirm to use this profile to quickly register with 
                    <b class="font-weight-bold">{{ getOrgNameOrAcronym }}</b>
                     and this campaign or Cancel to exit.
                  </p>
                </div>
                <div v-else-if="!(getCampaignById.is_tfw_campaign && candidateInfo?.organisation_id === 148)">
                  Non-TFW campaign – candidate registered with TFW
                  <p class="mb-2">
                    <span class="font-weight-bold">
                      {{ candidateInfo.org_name || candidateInfo.customer_name }}
                    </span>, is a member of the TalentFind Marketplace network – the global
                    healthcare careers hub. You’re already registered and have a
                    TalentFind profile. 
                  </p>
                  <p>
                    Press Confirm to use this profile to quickly register with 
                    <b class="font-weight-bold">{{ getOrgNameOrAcronym }}</b>
                     and this campaign or Cancel to exit.
                  </p>
                </div>

                <div class="my-2 text-center" v-if="!candidateInfo.is_campaign">
                  <CButton variant="outline" color="primary" @click="routeToCampaignLogin()">Cancel</CButton>
                  <CButton color="primary ml-3" v-if="isAlreadyRegistered" @click="showPasswordInput = true">Register</CButton>
                  <CButton color="primary ml-3" v-else @click="showPreReg()">Confirm</CButton>
                </div>
              </div>
            </CCardBody>
          </CCard>
        </div>
      </CCol>
    </CRow>
    <div 
      class="d-flex justify-content-center align-items-center mt-5"
      v-if="showPasswordInput">
      <CCard style="width: 500px">
        <CCardBody>
          <CCardTitle 
            class="text-primary text-center h2 mb-4" 
            style="font-weight: 500;">
            Welcome To {{ getOrgNameOrAcronym }}
          </CCardTitle>
          <h3 class="mb-2">
            Hello 
            <span class="text-primary" >
              {{ candidateDetails.candidate_name | toTitleCase }}!
            </span>
          </h3>
          <CRow class="mb-3">
            <CCol md="12" class="font-weigth-bold mb-2">
              Please Enter your Password
            </CCol>
            <CCol>
              <ValidationProvider rules="required" v-slot="{ errors }" ref="existingCandidatePassword">
                <TextInput
                  name="password"
                  type="password"
                  :value="candidate_email.password"
                  @input="handleInput"
                  :error="errors[0]"
                />
              </ValidationProvider>
            </CCol>
          </CRow>
          <CRow>
            <CCol class="text-left">
              <CButton
                @click="redirectToForgot"
                color="link"
                class="px-0"
                >Forgot password?</CButton
              >
            </CCol>
          </CRow>
          <CRow class="d-flex justify-content-center">
            <CButton class="btn-secondary mr-3" @click="routeToCampaignLogin()">
              Back
            </CButton>
            <CButton
              class="btn-primary"
              :disabled=isLoading
              @click="onExistingCandidate()"
              >Register</CButton
            >
          </CRow>
        </CCardBody>
      </CCard>
    </div>
    <Modal
      size="lg"
      :modalTitle="CampaignAdditionalInfoModal.title"
      :modalColor="CampaignAdditionalInfoModal.color"
      :innerHTML="CampaignAdditionalInfoModal.innerHTML"
      :isShowPopup="CampaignAdditionalInfoModal.isShowPopup"
      :buttons="CampaignAdditionalInfoModal.buttons"
      :modalCallBack="CampaignAdditionalInfoModalCallBack"
      :closeOnBackdrop="false"
    />
  </div> -->
</template>

<script>
import { extend } from "vee-validate";
import { email, required, confirmed } from "vee-validate/dist/rules";
import { BASE_URL } from "@/service_urls";
import Vue from "vue";

import TextInput from "@/components/reusable/Fields/TextInput";
import Modal from "@/components/reusable/Modal.vue";

import { mapActions, mapGetters } from "vuex";

extend("email", { ...email, message: "Invalid email" });
extend("required", { ...required, message: "This field is required" });
extend("emailConfirmed", { ...confirmed, message: "The email addresses entered do not match. Please correct and try again." });

import { LOGIN_URL, getLocalOrgDetail, redirectToRegistrationUrl, isSuperCustomer } from "@/helpers/helper";
export default {
  name: "CampaignLogin",
  components: {
    TextInput,
    Modal
  },
  data() {
    return {
      candidate_email: {},
      isFetching: false,
      candidateInfo: null,
      width: null,
      height : null,
      showPasswordInput: false,
      candidateDetails: null,
      isAlreadyRegistered: false,
      isLoading: false,
      isAlreadyRegWithCurrentOrg: false,
      step: 1,
      CampaignAdditionalInfoModal: {
        isShowPopup: false,
        title: "Campaign Information",
        innerHTML: "",
        color: "primary",
        buttons: ["Close"]
      },
    };
  },
  computed: {
    ...mapGetters([
      "getCampaignById",
      "getCandidateData",
      "getOrgDetail",
      "isSuperCustomer",
      "getOrgName",
      "isCandidateRoleFromAccessToken",
      "getCandidateCampaignInfo",
      "getCustomerOrganisationID"
    ]),
    getBackgroundImage() {
      const defaultBackground = "/img/new_home_bg.png";
      if (this.getCampaignById && this.getCampaignById.uuid_background_image_link_to_doc) {
          return `${BASE_URL}${this.getCampaignById.uuid_background_image_link_to_doc.replace("/api/v1", "")}?file=background_image&${new Date().getTime()}`;
      } else {
          return defaultBackground;
      }
    },
    getScreenSize() {
      return {
        width: screen.width,
        height: screen.height,
      };
    },
    getLogoImage() {
      return `${BASE_URL}${this.getCampaignById?.uuid_logo_link_to_doc?.replace(
        "/api/v1",
        ""
      )}?file=logo&${new Date().getTime()}`;
    },
    isTFW() {
      return this.$route.params.org_name === "tfw";
    },
    candidateName() {
      return this.candidateInfo
        ? `${this.candidateInfo?.first_name} ${this.candidateInfo.sur_name}`
        : null;
    },
    isRegCandidate() {
      return this.candidateInfo?.candidate_uid || false;
    },
    isLessDimensionImg() {
      if(this.width && this.height && this.width < 680 && this.height < 752 ) {
        return true;
      }
      return false;
    },
    getCustomerID() {
      return getLocalOrgDetail()?.customer_uid || null;
    },
    getOrgID() {
      return getLocalOrgDetail()?.organisation_id || null;
    },
    getLocationID() {
      return getLocalOrgDetail()?.location_id || null;
    },
    getOrgNameOrAcronym() {
      return  this.getOrgDetail.name ?  this.getOrgDetail.name : this.getPathAcronym.toUpperCase()
    },
    getPathAcronym() {
      let { path_acronym } = getLocalOrgDetail();
      return path_acronym;
    },
  },
  methods: {
    ...mapActions([
      "fetchCampaignById",
      "getRegisteredHospitalsByEmail",
      "showToast",
      "checkCandidateExistInCampaign",
      "registerCommonCandidate",
      "login",
    ]),
    handleImageError(event) {
      event.target.src = "/img/new_home_bg.png";
      event.target.style.width = this.getScreenSize.width + "px";
      event.target.style.height = this.getScreenSize.height + "px";
    },
    handleEmailInput(name, value) {
      Vue.set(this.candidate_email, name, (value?.toLowerCase().trim()))
    },
    showPreReg() {
      this.$emit("candidateData", this.candidateInfo);
    },
    navToLogin() {
      this.$router.push({ path: LOGIN_URL() });
    },
    async checkCandidateExists() {
      const isValid = await this.$refs.login_campaign.validate();
      if (!isValid) {
        this.showToast({
          class: "bg-danger text-white",
          message: "please fill mandatory field!",
        });
        return;
      }
      if (!this.candidate_email["email"]) {
        this.showToast({
          class: "bg-danger text-white",
          message: "Enter valid email!",
        });
        return false;
      }
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(String(this.candidate_email["email"]).toLowerCase())) {
        this.showToast({
          class: "bg-danger text-white",
          message: "Enter valid email!",
        });
        return false;
      }
      if(this.candidate_email["email"] === this.candidate_email["confirm_email"]) {
        this.step = 0;
        const payload = {
          email: this.candidate_email["email"],
          campaign_id: this.getCampaignById.campaign_id,
        };
        this.candidateInfo = null;
        const finalPayload = {
              email: this.candidate_email["email"],
              customer_uid: this.getCustomerID,
              organisation_uid: this.getOrgID || null,
              check_registered: true
            };
        try {
          const res = await this.getRegisteredHospitalsByEmail(finalPayload);
          if (res.status === 200 && res?.data?.[0]) {
            this.candidateDetails = res?.data?.[0];
            this.isAlreadyRegistered = true;
          } else if(res.response.status === 400) {
            this.checkCandidateExistsInCampaign(payload);
            this.isAlreadyRegWithCurrentOrg = true;
            return
          } else {
            this.candidateDetails = res.data
          }
        } catch (err) {
          console.log(err);
        }
        this.checkCandidateExistsInCampaign(payload);
      } else {
          this.showToast({
            class: "bg-danger text-white",
            message: "The email addresses entered do not match. Please correct and try again.",
          });
          return false;
      };
    },
    async checkCandidateExistsInCampaign(payload) {
      await this.checkCandidateExistInCampaign(payload).then((res) => {
          if (res) {
            let data = {
              is_pre_register: true,
              email: this.candidate_email.email,
              first_name: res?.first_name,
              sur_name: res?.sur_name ?? null,
              phone: res?.phone ?? null,
              candidate_uid: res?.candidate_uid ?? null,
              is_campaign: res?.is_campaign ?? null,
              campaign_pre_reg_candidate_id: res?.campaign_pre_reg_candidate_id ?? null,
              candidate_type_id: res.candidate_type_id ?? null,
              candidate_type: res?.candidate_type?.candidate_type ?? null,
              org_name: res?.org_name ?? null,
              organisation_id: res?.organisation?.organisation_id ?? null,
              register_now: false,
              completed: res?.completed ?? null,
            };
            this.candidateInfo = data;
            if (this.isAlreadyRegWithCurrentOrg) {
              this.$store.commit("SET_CAMPAIGN_CANDIDATE_DETAILS", data);
              // data.step = 2;
              this.$emit("candidateData", data);
            } else if(!this.isRegCandidate) {
              this.$emit("candidateData", data);
            }
          } else {
            const data = {
              is_pre_register: true,
              email: this.candidate_email.email,
              register_now: true,
            };
            this.$emit("candidateData", data);
          }
        });
    },
    getImageSize() {
      const img = new Image();
      img.src = this.$refs.campaign_bg_img?.src;
      img.onload = () => {
          this.width = img.width;
          this.height = img.height;
      };
    },
    handleInput(name, value) {
      Vue.set(this.candidate_email, name, value)
    },
    async onExistingCandidate() {
      this.$refs.existingCandidatePassword.validate();
      const isPasswordEntered = this.candidate_email?.password;

      if (isPasswordEntered) {
        try {
          this.isLoading = true;
          let payload = {
            email: this.candidate_email?.email,
            customer_uid: this.getCustomerID,
            organisation_id: this.getOrgID,
            location_id: this.getLocationID || null,
            password: isPasswordEntered,
          };

          await this.registerCommonCandidate(payload)
          .then(async () => {
            const data = {
              username: this.candidate_email?.email,
              password: isPasswordEntered,
            };
            this.$store.commit("SET_CAMPAIGN_WELCOME_DATA", { 
              org_name: this.getOrgNameOrAcronym || null,
              campaign_name: this.getCampaignById?.campaign_name || null,
              is_campaign: true 
            });

            await this.login(data);
          });
        } catch (error) {
          console.error("An error occurred:", error);
        } finally {
          this.isLoading = false;
        }
      }
    },
    redirectToForgot() {
      this.$router.push({
        path: `${
          this.isAcronymBasedLogin ? `${LOGIN_URL()}/forgot` : "/forgot"
        }`,
      });
    },
    routeToCampaignLogin() {
      this.candidateInfo = {}
      this.candidate_email= {}
      this.showPasswordInput = false
      this.step = 1
    },
    handleCampaignRoute(isRegistered) {
      localStorage.setItem(
        "campaignID",
        this.getCampaignById.campaign_uuid
      );
      if(isRegistered) {
        if(this.isSuperCustomer) {
          this.$router.push("/tfm/register#register-form");
          return;
        } else {
          this.navToLogin();
          return;
        }
      } else {
        let url ="";
        if (this.isSuperCustomer) {
          url = `/tfm/register/#register-form`;
          this.$router.push(url);
          return;
        } else{
          url = redirectToRegistrationUrl();
        }
        this.$router.push(url);
      }
    },
    CampaignAdditionalInfoModalCallBack(action) {
      if(action === false || action === "Close") {
        this.CampaignAdditionalInfoModal.isShowPopup = false;
      }
    },
    openCampaignAdditionalInfoModal(content) {
      this.CampaignAdditionalInfoModal.innerHTML =`${content}`;
      this.CampaignAdditionalInfoModal.isShowPopup = true;
    },
    proceedWithCampaignQuestions(value) {
      this.$emit("proceedWithCampaignQuestions", value);
    },
    goHome() {
      this.$router.push(`/home?tab=5`);
    },
  },
  mounted() {
    this.isFetching = true;
    const {
      params: { campaign_id: cid },
    } = this.$router.currentRoute;
    this.campaign_id = cid || "";
    this.candidateInfo = null;
    this.fetchCampaignById(this.campaign_id);

    if( this.getCampaignById?.customer_organisation_id !== this.getCustomerOrganisationID ) {
      localStorage.removeItem("campaignID");
      console.error("Campaign organisation does not match with candidate's registered organisation. Redirecting to home page.");
      return this.$router.push(`/home`);
    } else if(this.isCandidateRoleFromAccessToken) {
      localStorage.removeItem("campaignID");
    }

    this.isFetching = false;
  },
  filters: {
    toTitleCase(data) {
      return data ? _.startCase(data) : data;
    }
  }
};
</script>

<style lang="scss" scoped>
.bg {
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

@media (max-width: 1084px) {
  #bg-img {
    display: none;
  }
}
.container {
  .card-group {
    .card {
      max-width: 450px;
      @media (min-width: 1000px) {
        margin-top: 50px;
      }
    }
  }
}
.page-fix {
  margin-top: -22px;
  margin-right: -30px;
  margin-left: -30px;
  min-height: 100vh;
  background-color: white;
  background-repeat: no-repeat;
}
.istfw {
  padding-top: 22px;
}
.btn-width {
  width: 120px;
}
.bg-cover {
  background-size: cover;
}

.logo-wrapper {
  width: 120px;   
  height: 120px;     
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 50%;          
  border: 2px solid #e5e7eb;
}

.logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;  
}

.campaign-bg {
  background-size: cover;      
  background-position: center; 
  background-repeat: no-repeat; 
  min-height: 100vh;             
}
</style>
